import {HOVER_COLOR, ProcessNodeEditor} from "./ProcessNodeEditor";
import {BoxedObjectEditor} from "./BoxedObjectEditor";

export const GATEWAY_WIDTH = 60;
export const GATEWAY_HEIGHT = 60;

const HALF_PI = Math.round(1000*Math.PI/2);

export class GatewayEditor extends ProcessNodeEditor {
	constructor(parent, node, coords) {
		super(parent, node, coords, true);
	}


	get bg() {
		return this.hovered ? HOVER_COLOR : "#f6edff";
	}

	get typeColor() {
		return "#C5BECC";
	}

	draw(ctx) {
		const rect = BoxedObjectEditor.strokeBox(this.coords.x, this.coords.y, this.coords.w, this.coords.h, this.lineWidth);
		ctx.save();
		ctx.strokeStyle = this.selected ? S.HI_COLORS[8] : "black";
		ctx.fillStyle = this.bg;
		ctx.lineWidth = this.lineWidth;
		ctx.lineJoin = "bevel";
		ctx.beginPath();
		ctx.moveTo(rect.left + rect.width / 2, rect.top);
		ctx.lineTo(rect.left + rect.width, rect.top + rect.height / 2);
		ctx.lineTo(rect.left + rect.width / 2, rect.top + rect.height);
		ctx.lineTo(rect.left, rect.top + rect.height / 2);
		ctx.closePath();
		ctx.fill();
		ctx.stroke();
		ctx.restore();

		this.drawTypeSymbol(ctx, rect);

		this.drawNodeName(ctx, rect);
	}

	drawTypeSymbol(ctx, rect) {
	}

	calcIncomingArrowTip(angle) {
		const w = this.coords.w/2;
		const h = this.coords.h/2;
		const h2 = Math.abs(w * Math.tan(angle));
		let x = (h * w)/(h + h2);
		let y = (h * (w - x))/w;

		let quadrant = Math.floor(angle/(Math.PI/2))%4;
		if (quadrant < 0) quadrant += 4;

		if (quadrant === 1 || quadrant === 2) x = -x;
		if (quadrant === 2 || quadrant === 3) y = -y;

		return {
			tipX: this.coords.x - x,
			tipY: this.coords.y - y,
			angle: angle
			/* ,debug: "x=" + Math.round(x) + " y=" + Math.round(y) */
		};
	}
}